export default "__VITE_ASSET__Cg84maap__"